module.exports = __webpack_public_path__ + "img/115.cc9c2752.png";